//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import eqpgContext from '../../context/eqpgContext/eqpgContex';
import './FormEqpg.css';

function FormEqpg({data, setData, minimizar, nuevoEditado, handleChangeEqpgs, index, tDocID = '' }){

    const eContext = useContext(eqpgContext);
    const {agregarEqpg, actualizarEqpgLista, modificarEqpg, eliminarEqpg} = eContext;

    const [eqpg, setEqpg] = useState({codEqpg:"",name: ''});

    const [titulo, setTitulo] = useState(nuevoEditado);

    const validacion =  () => {
        const newErrors = {};
        if (eqpg.codEqpg === '' || eqpg.codEqpg === undefined) return newErrors.codigo = 'El código de EQPG debe ser colocado'
        if (eqpg.name === '' || eqpg.name === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        return '';
    };

    const handlerGenerar = async ()  => {

        const errorAxi = validacion();

        if ( errorAxi === "" ) {

            try {
                const dato = eqpg;
                const res = await agregarEqpg(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo un nuevo EQPG`,
                        icon: 'success',
                        text: `Código: ${res.codEqpg} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarEqpgLista();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del EQPG",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {

            try {
                const dato = {
                    id: data.id,
                    codEqpg:eqpg.codEqpg,
                    name: eqpg.name
                }
                await setData(dato);
                const res = await modificarEqpg(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó el EQPG`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codEqpg}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarEqpgLista();
                    minimizar();
                    let eqpgToChange = {id:res._id, label:res.name, value:res.codEqpg, name:res.name};
                    handleChangeEqpgs(eqpgToChange,index);
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del EQPG",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar este EQPG?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
                const id = data.id
                const resp = await eliminarEqpg(id, tDocID);
                if(resp.data.delete){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El EQPG fue borrado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizarEqpgLista();
                    handleChangeEqpgs({},index);
                    minimizar(null);
                }else{
                    Swal.fire({
                        title: `Operacion no puede realizarse`,
                        icon: 'error',
                        text: `${resp.data.msg}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                }
            } else if (result.isDismissed) {
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            let codigoEqpg = (data.codEqpg != undefined) ? data.codEqpg : data.value;
            let eqpgModelado = {id:data?.eqpgID, codEqpg:codigoEqpg, name: data?.name};
            setEqpg(eqpgModelado);
        }
    },[data])

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Equipamiento Protección Grupal
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de EQPG: </div>
                <input disabled={ titulo === "Modificar"} value={eqpg.codEqpg} className='label-form-group-data' onChange={data => setEqpg({ ...eqpg, ['codEqpg']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={eqpg.name} className='label-form-group-data' onChange={data => setEqpg({ ...eqpg, ['name']: data.target.value })} />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormEqpg;
